define('lib/backbone/Backbone.Mixins.PodioInfiniteScrollView',['require','underscore','jst!shared/generic_loader_small'],function (require) {

  var _ = require('underscore');
  var jstGenericLoadSmall = require('jst!shared/generic_loader_small');

  return {
    elmItemsContainer: null,      /* set to the parent of the container where items will reside */
    elmItemsList: null,           /* set to the actual container where the items reside (usually ul) */
    scrollOffset: 10,             /* when scrolling should start */
    reverseScroll: false,
    _enoughElementsLoaded: false, /* indicates whether we already have items filling out the height of the container */
    _loading: false,              /* indicates whether loading of items is in progress */

    onScroll: function() {
      var itemsContainer = this.elmItemsContainer.get(0);

      var scrollPosition;
      if(this.reverseScroll) {
        scrollPosition = itemsContainer.scrollTop;
      } else {
        scrollPosition = ((itemsContainer.scrollHeight - itemsContainer.clientHeight) - itemsContainer.scrollTop);
      }

      if (!this._loading && scrollPosition <= this.scrollOffset) {
        this.onScrollingTriggerPointReached();
      }
    },

    onScrollingTriggerPointReached: function() {
      var self = this;

      if (this.collection.endReached) {
        return false;
      }

      this._loading = true;
      this._showLoader();

      this.collection.loadChunk().done(function() {
        self._removeLoader();
        self._loading = false;
      });
    },

    onAddingFinished: _.debounce(function() {
      if (this.collection.endReached) {
        this._enoughElementsLoaded = true;
      }

      if (!this._enoughElementsLoaded) {
        this.loadHeightFillingItems();
      }
    }, 200),

    _showLoader: function() {
      var template = this.getTemplate(jstGenericLoadSmall);
      if(this.reverseScroll) {
        this.elmItemsContainer.prepend(template);
      } else {
        this.elmItemsContainer.append(template);
      }
    },

    _removeLoader: function() {
      this.elmItemsContainer.find('.loading-overlay-small').remove();
    },

    initPagination: function() {
      _.bindAll(this, 'loadHeightFillingItems', 'onScroll');
      this.listenTo(this.collection, 'add.infinitescroll', this.onAddingFinished);
      this.elmItemsContainer.scroll(this.onScroll);
      return this;
    },

    loadHeightFillingItems: function() {
      if (this.elmItemsList.outerHeight() < this.elmItemsContainer.outerHeight()) {
        this.collection.loadChunk();
      } else {
        this._enoughElementsLoaded = true;
      }

      return this;
    },

    disposePagination: function() {
      this.stopListening();
      this.elmItemsContainer.unbind('scroll', this.onScroll);
    }
  };

});

